import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import Job from '../views/Job.vue'
import AddEditJob from '../views/AddEditJob.vue'
import GetStarted from '../views/GetStarted.vue'
import Register from '../views/Register.vue'
import DisableJob from '../views/DisableJob.vue'
import Error404View from '../views/Error404.vue'
import AccountProfileView from '../views/Profile.vue'
import FaqView from '../views/FAQ.vue'
import ContactView from '../views/Contact.vue'
import TermsView from '../views/Terms.vue'
import PrivacyView from '../views/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: "/job",
    name: "new",
    component: GetStarted
  },
  {
    path: "/job/edit/:id",
    name: "edit",
    component: GetStarted
  },
  {
    path: "/jobs",
    name: "jobs",
    component: Job
  },
  {
    path: "/job-disable/:id",
    name: "disable",
    component: DisableJob
  },
  {
    path: '/profile',
    name: 'profile',
    component: AccountProfileView
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/get-started',
    name: 'get-started',
    component: GetStarted
  },
  {
    path: '*',
    name: "404",
    component: Error404View
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
